
import React, { useState } from "react";
import { FaUserCircle } from "react-icons/fa";

const dummyConversations = [
  {
    id: 1,
    name: "Jane Doe",
    lastMessage: "Thank you for the opportunity!",
    date: "May 26",
    messages: [
      { from: "candidate", text: "Hi, is the role still open?", date: "May 25" },
      { from: "employer", text: "Yes, please share your availability.", date: "May 25" },
      { from: "candidate", text: "Thank you for the opportunity!", date: "May 26" },
    ],
  },
  {
    id: 2,
    name: "John Smith",
    lastMessage: "I'll send it today.",
    date: "May 24",
    messages: [
      { from: "candidate", text: "Should I send a resume?", date: "May 24" },
      { from: "employer", text: "Yes, please email it today.", date: "May 24" },
    ],
  },
];

const EmployerMessages = () => {
  const [selectedChat, setSelectedChat] = useState(dummyConversations[0]);

  return (
    <div className="flex-1 bg-[#f9fafb] p-6 min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">Messages</h1>

      <div className="flex border rounded-lg bg-white shadow overflow-hidden h-[90vh]">
        {/* Conversation List */}
        <div className="w-1/3 border-r overflow-y-auto">
          {dummyConversations.map((conv) => (
            <div
              key={conv.id}
              className={`p-4 cursor-pointer hover:bg-gray-100 ${
                selectedChat.id === conv.id ? "bg-gray-50 border-l-4 border-[#004349]" : ""
              }`}
              onClick={() => setSelectedChat(conv)}
            >
              <div className="flex items-center gap-3">
                <FaUserCircle className="text-2xl text-gray-500" />
                <div>
                  <p className="font-semibold text-gray-800">{conv.name}</p>
                  <p className="text-xs text-gray-600 truncate w-[150px]">{conv.lastMessage}</p>
                  <p className="text-xs text-gray-400">{conv.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Message Thread */}
        <div className="w-2/3 flex flex-col justify-between">
          <div className="p-4 overflow-y-auto h-full">
            <h2 className="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">
              Conversation with {selectedChat.name}
            </h2>
            {selectedChat.messages.map((msg, i) => (
              <div
                key={i}
                className={`mb-3 flex ${
                  msg.from === "employer" ? "justify-end" : "justify-start"
                }`}
              >
                <div
                  className={`max-w-sm px-4 py-2 rounded-lg text-sm ${
                    msg.from === "employer"
                      ? "bg-black text-white"
                      : "bg-gray-100 text-gray-800"
                  }`}
                >
                  {msg.text}
                  <div className="text-xs text-gray-300 mt-1 text-right">{msg.date}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Input Area */}
          <div className="p-4 border-t bg-gray-50">
            <form className="flex items-center gap-3">
              <input
                type="text"
                placeholder="Type a message..."
                className="flex-1 border px-4 py-2 rounded-lg focus:outline-none"
              />
              <button
                type="submit"
                className="bg-black  text-white px-4 py-2 rounded-lg font-medium text-sm"
              >
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployerMessages;
